<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout pa-6 mt-3 style="background-color: #3E7662;">
              <v-flex
                d-flex
                justify-start
                align-center
                style="font-size: 28px;color: white"
              >
                <div style="font-weight: bold" @click="setData">
                  ใบตอบรับเอกสาร Receipt
                </div>
              </v-flex>
              <v-flex
                d-flex
                justify-end
                align-center
                style="font-weight: bold;font-size: 13px;color: white"
              >
                <span>RO 02_2560</span>
              </v-flex>
            </v-layout>

            <!-- Start Form -->

            <!-- Start Card 1 -->
            <v-card>
              <!-- Logo -->
              <v-layout style="padding: 50px 100px 5px 100px">
                <v-flex>
                  <img src="../../assets/LogoTh.png" width="124" alt="" />
                </v-flex>
              </v-layout>

              <!-- Header -->
              <v-layout style="margin-bottom: 30px;">
                <v-flex>
                  <div style="font-weight: bold;font-size: 20px;">
                    คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก
                    ยืนยันการได้รับเอกสาร ดังรายการต่อไปนี้
                  </div>
                </v-flex>
              </v-layout>

              <!-- Start Table -->
              <v-layout class="table-ro">
                <v-flex class="table-style">
                  <table class="table-fill">
                    <thead>
                      <tr>
                        <th width="45%" class="text-center">
                          เอกสาร (documents)
                        </th>
                        <th width="13%" class="text-center">เลขที่รับ</th>
                        <th width="13%" class="text-center">Version</th>
                        <th width="15%" class="text-center">Dated</th>
                        <th width="13%" class="text-center">(ชุด/หน้า/แผ่น)</th>
                      </tr>
                    </thead>
                    <tbody class="table-hover">
                      <!-- row 1 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasProtocolInitial"
                            color="#3E7662"
                            label="โครงร่างการวิจัยส่งครั้งแรก (Protocol_Initial submission)"
                            hide-details
                            @change="checkbox('hasProtocolInitial')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolInitial"
                            :background-color="
                              !form.hasProtocolInitial ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.receiverAndSender"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolInitial"
                            :background-color="
                              !form.hasProtocolInitial ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionProtocolInitial"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasProtocolInitial"
                                :background-color="
                                  !form.hasProtocolInitial
                                    ? '#E0E0E0'
                                    : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange1"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date1')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolInitial"
                            :background-color="
                              !form.hasProtocolInitial ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberProtocolInitial"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 2 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasCorrectedProtocol"
                            color="#3E7662"
                            label="โครงร่างการวิจัยที่แก้ไขตามข้อแนะนํา (Corrected Protocol)"
                            hide-details
                            @change="checkbox('hasCorrectedProtocol')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCorrectedProtocol"
                            :background-color="
                              !form.hasCorrectedProtocol ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialCorrectedProtocol"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCorrectedProtocol"
                            :background-color="
                              !form.hasCorrectedProtocol ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionCorrectedProtocol"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasCorrectedProtocol"
                                :background-color="
                                  !form.hasCorrectedProtocol
                                    ? '#E0E0E0'
                                    : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange2"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date2')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCorrectedProtocol"
                            :background-color="
                              !form.hasCorrectedProtocol ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberCorrectedProtocol"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 3 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasAmendment"
                            color="#3E7662"
                            label="ส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment)"
                            hide-details
                            @change="checkbox('hasAmendment')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasAmendment"
                            :background-color="
                              !form.hasAmendment ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialAmendment"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasAmendment"
                            :background-color="
                              !form.hasAmendment ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionAmendment"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasAmendment"
                                :background-color="
                                  !form.hasAmendment ? '#E0E0E0' : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange3"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date3')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasAmendment"
                            :background-color="
                              !form.hasAmendment ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberAmendment"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 4 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasSAE"
                            color="#3E7662"
                            label="รายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง (SAE)"
                            hide-details
                            @change="checkbox('hasSAE')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasSAE"
                            :background-color="
                              !form.hasSAE ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialSAE"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasSAE"
                            :background-color="
                              !form.hasSAE ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionSAE"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasSAE"
                                :background-color="
                                  !form.hasSAE ? '#E0E0E0' : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange4"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date4')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasSAE"
                            :background-color="
                              !form.hasSAE ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberSAE"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 5 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasProgressReport"
                            color="#3E7662"
                            label="รายงานความก้าวหน้า (Progress Report)"
                            hide-details
                            @change="checkbox('hasProgressReport')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProgressReport"
                            :background-color="
                              !form.hasProgressReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialProgressReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProgressReport"
                            :background-color="
                              !form.hasProgressReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionProgressReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date5"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasProgressReport"
                                :background-color="
                                  !form.hasProgressReport
                                    ? '#E0E0E0'
                                    : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange5"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date5')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProgressReport"
                            :background-color="
                              !form.hasProgressReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberProgressReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 6 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasFinalReport"
                            color="#3E7662"
                            label="รายงานสรุปผลการวิจัย (Final Report / Premature termination)"
                            hide-details
                            @change="checkbox('hasFinalReport')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasFinalReport"
                            :background-color="
                              !form.hasFinalReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialFinalReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasFinalReport"
                            :background-color="
                              !form.hasFinalReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionFinalReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date6"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasFinalReport"
                                :background-color="
                                  !form.hasFinalReport ? '#E0E0E0' : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange6"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date6')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasFinalReport"
                            :background-color="
                              !form.hasFinalReport ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberFinalReport"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 7 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasProtocolDeviation"
                            color="#3E7662"
                            label="รายงานการเบี่ยงเบน (Protocol Deviation)"
                            hide-details
                            @change="checkbox('hasProtocolDeviation')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolDeviation"
                            :background-color="
                              !form.hasProtocolDeviation ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialProtocolDeviation"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolDeviation"
                            :background-color="
                              !form.hasProtocolDeviation ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionProtocolDeviation"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date7"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasProtocolDeviation"
                                :background-color="
                                  !form.hasProtocolDeviation
                                    ? '#E0E0E0'
                                    : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange7"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date7')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasProtocolDeviation"
                            :background-color="
                              !form.hasProtocolDeviation ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberProtocolDeviation"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 8 -->
                      <tr>
                        <td class="text-left">
                          <v-checkbox
                            v-model="form.hasCD"
                            color="#3E7662"
                            label="CD / DVD"
                            hide-details
                            @change="checkbox('hasCD')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCD"
                            :background-color="
                              !form.hasCD ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialCD"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCD"
                            :background-color="
                              !form.hasCD ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionCD"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date8"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasCD"
                                :background-color="
                                  !form.hasCD ? '#E0E0E0' : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange8"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date8')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasCD"
                            :background-color="
                              !form.hasCD ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberCD"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                      <!-- row 9 -->
                      <tr>
                        <td class="text-left">
                          <v-layout>
                            <v-flex shrink mr-2 d-flex align-center>
                              <v-checkbox
                                class="d-inline-block"
                                v-model="form.hasOther"
                                color="#3E7662"
                                label="อื่นๆ ระบุ"
                                hide-details
                                @change="checkbox('hasOther')"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex mt-n1 d-flex align-center>
                              <v-text-field
                                :disabled="!form.hasOther"
                                v-model="form.detailOther"
                                item-color="#3E7662"
                                color="#3E7662"
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasOther"
                            :background-color="
                              !form.hasOther ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.initialOther"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasOther"
                            :background-color="
                              !form.hasOther ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.versionOther"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                        <td class="text-left text-field-center">
                          <v-menu
                            v-model="menu_date9"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="!form.hasOther"
                                :background-color="
                                  !form.hasOther ? '#E0E0E0' : '#ffffff'
                                "
                                class="d-inline-block"
                                v-model="dateChange9"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                outlined
                                dense
                                hide-details
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              @input="selectDate($event, 'menu_date9')"
                              locale="th"
                              type="date"
                              color="#3E7662"
                              header-color="#3E7662"
                            ></v-date-picker>
                          </v-menu>
                        </td>
                        <td class="text-left text-field-center">
                          <v-text-field
                            :disabled="!form.hasOther"
                            :background-color="
                              !form.hasOther ? '#E0E0E0' : '#ffffff'
                            "
                            v-model="form.numberOther"
                            color="#3E7662"
                            outlined
                            dense
                            hide-details
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
              <!-- End Table -->

              <!-- Form Date -->
              <v-layout
                my-12
                justify-space-between
                style="padding: 50px 100px 50px 100px"
              >
                <v-flex xs6>
                  <v-layout>
                    <v-flex
                      mr-4
                      shrink
                      d-flex
                      align-center
                      class="text-start"
                      style="font-weight: bold"
                    >
                      <span>วันที่พิจารณาโครงร่างการวิจัย</span>
                    </v-flex>
                    <v-flex xs5 d-flex align-center class="text-start">
                      <v-menu
                        v-model="considerDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="considerDateChange"
                            readonly
                            hide-details
                            append-icon="date_range"
                            background-color="#FBF6F3"
                            item-color="#3E7662"
                            color="#3E7662"
                            filled
                            outlined
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          @input="selectDate($event, 'considerDate')"
                          locale="th"
                          type="date"
                          color="#3E7662"
                          header-color="#3E7662"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <v-layout justify-space-between>
                    <v-spacer></v-spacer>
                    <v-flex xs5 d-flex align-center class="text-start">
                      <v-menu
                        v-model="considerDate2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="considerDate2Change"
                            readonly
                            hide-details
                            append-icon="date_range"
                            background-color="#FBF6F3"
                            item-color="#3E7662"
                            color="#3E7662"
                            filled
                            outlined
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          @input="selectDate($event, 'considerDate2')"
                          locale="th"
                          type="date"
                          color="#3E7662"
                          header-color="#3E7662"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!--signature-->
              <v-layout
                justify-space-between
                style="padding: 50px 100px 50px 100px"
              >
                <v-flex mr-6>
                  <v-layout>
                    <v-flex shrink pt-5 class="text-start text-field-center">
                      <span style="font-weight: bold;">ผู้ประสานงาน</span>
                    </v-flex>
                    <v-flex
                      pl-2
                      d-flex
                      align-center
                      class="text-end text-field-center"
                    >
                      <v-text-field
                        v-model="form.coordinator"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex ml-6>
                  <v-layout>
                    <v-flex xs4 pt-5 class="text-end">
                      <span style="font-weight: bold;">ผู้ลงนามรับเอกสาร</span>
                    </v-flex>
                    <v-flex
                      pl-2
                      d-flex
                      align-center
                      class="text-end text-field-center"
                    >
                      <v-text-field
                        hide-details
                        v-model="form.receiver"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs4></v-flex>
                    <v-flex style="font-weight: bold" class="text-field-center">
                      <span>(</span>
                      <v-text-field
                        class="d-inline-block"
                        v-model="form.receiver"
                        color="#3E7662"
                      />
                      <span>)</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-6 style="padding: 50px 100px 50px 100px">
                <v-spacer></v-spacer>
                <v-flex xs6>
                  <v-layout>
                    <v-flex xs4 shrink pt-5 class="text-end">
                      <span style="font-weight: bold;">ผู้รับส่งเอกสาร</span>
                    </v-flex>
                    <v-flex
                      pl-2
                      d-flex
                      align-center
                      class="text-end text-field-center"
                      style="font-weight: bold"
                    >
                      <v-text-field
                        hide-details
                        v-model="form.receiverAndSender"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs4></v-flex>
                    <v-flex style="font-weight: bold" class="text-field-center">
                      <span>(</span>
                      <v-text-field
                        class="d-inline-block"
                        v-model="form.receiverAndSender"
                        color="#3E7662"
                      />
                      <span>)</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout style="padding: 50px 100px 50px 100px">
                <v-flex style="font-weight: bold" class="text-start">
                  <div>
                    หมายเลขโทรศัพท์ติดต่อ 02-3549011 ,02-3547600-28 ต่อ 94297
                  </div>
                  <div>อีเมล์ : irbrta@yahoo.com, irbrta@amed.go.th</div>
                  <div>
                    เว็บไซต์ : www.irbrta.pmk.ac.th,
                    www.amed.go.th/rtamed/irbrta/
                  </div>
                </v-flex>
              </v-layout>

              <v-layout style="padding: 50px 100px 50px 100px">
                <v-flex class="text-start">
                  <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                </v-flex>
              </v-layout>
            </v-card>
            <!--End Card 1 -->

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="$router.go(-1)"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <!--                                            <v-icon class="mr-3">add</v-icon>-->
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      hasProtocolInitial: "",
      initialProtocolInitial: "",
      versionProtocolInitial: "",
      dateProtocolInitial: "",
      numberProtocolInitial: "",
      hasCorrectedProtocol: "",
      initialCorrectedProtocol: "",
      versionCorrectedProtocol: "",
      dateCorrectedProtocol: "",
      numberCorrectedProtocol: "",
      hasAmendment: "",
      initialAmendment: "",
      versionAmendment: "",
      dateAmendment: "",
      numberAmendment: "",
      hasSAE: "",
      initialSAE: "",
      versionSAE: "",
      dateSAE: "",
      numberSAE: "",
      hasProgressReport: "",
      initialProgressReport: "",
      versionProgressReport: "",
      dateProgressReport: "",
      numberProgressReport: "",
      hasFinalReport: "",
      initialFinalReport: "",
      versionFinalReport: "",
      dateFinalReport: "",
      numberFinalReport: "",
      hasProtocolDeviation: "",
      initialProtocolDeviation: "",
      versionProtocolDeviation: "",
      dateProtocolDeviation: "",
      numberProtocolDeviation: "",
      hasCD: "",
      initialCD: "",
      versionCD: "",
      dateCD: "",
      numberCD: "",
      hasOther: "",
      detailOther: "",
      initialOther: "",
      versionOther: "",
      dateOther: "",
      numberOther: "",
      considerDate: "",
      considerDate2: "",
      coordinator: "",
      receiver: "",
      receiverAndSender: "",
    },
    menu_date1: false,
    menu_date2: false,
    menu_date3: false,
    menu_date4: false,
    menu_date5: false,
    menu_date6: false,
    menu_date7: false,
    menu_date8: false,
    menu_date9: false,
    dateChange1: "",
    dateChange2: "",
    dateChange3: "",
    dateChange4: "",
    dateChange5: "",
    dateChange6: "",
    dateChange7: "",
    dateChange8: "",
    dateChange9: "",

    considerDate: false,
    considerDateChange: "",
    considerDate2: false,
    considerDate2Change: "",
  }),
  created() {
    this.getRO02();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    checkbox(name) {
      if (name === "hasProtocolInitial") {
        if (!this.form.hasProtocolInitial) {
          this.form.initialProtocolInitial = "";
          this.form.versionProtocolInitial = "";
          this.form.dateProtocolInitial = "";
          this.form.numberProtocolInitial = "";
        }
      }
      if (name === "hasCorrectedProtocol") {
        if (!this.form.hasCorrectedProtocol) {
          this.form.initialCorrectedProtocol = "";
          this.form.versionCorrectedProtocol = "";
          this.form.dateCorrectedProtocol = "";
          this.form.numberCorrectedProtocol = "";
        }
      }
      if (name === "hasAmendment") {
        if (!this.form.hasAmendment) {
          this.form.initialAmendment = "";
          this.form.versionAmendment = "";
          this.form.dateAmendment = "";
          this.form.numberAmendment = "";
        }
      }
      if (name === "hasSAE") {
        if (!this.form.hasSAE) {
          this.form.initialSAE = "";
          this.form.versionSAE = "";
          this.form.dateSAE = "";
          this.form.numberSAE = "";
        }
      }
      if (name === "hasProgressReport") {
        if (!this.form.hasProgressReport) {
          this.form.initialProgressReport = "";
          this.form.versionProgressReport = "";
          this.form.dateProgressReport = "";
          this.form.numberProgressReport = "";
        }
      }
      if (name === "hasFinalReport") {
        if (!this.form.hasFinalReport) {
          this.form.initialFinalReport = "";
          this.form.versionFinalReport = "";
          this.form.dateFinalReport = "";
          this.form.numberFinalReport = "";
        }
      }
      if (name === "hasProtocolDeviation") {
        if (!this.form.hasProtocolDeviation) {
          this.form.initialProtocolDeviation = "";
          this.form.versionProtocolDeviation = "";
          this.form.dateProtocolDeviation = "";
          this.form.numberProtocolDeviation = "";
        }
      }
      if (name === "hasCD") {
        if (!this.form.hasCD) {
          this.form.initialCD = "";
          this.form.versionCD = "";
          this.form.dateCD = "";
          this.form.numberCD = "";
        }
      }
      if (name === "hasOther") {
        if (!this.form.hasOther) {
          this.form.initialOther = "";
          this.form.detailOther = "";
          this.form.versionOther = "";
          this.form.dateOther = "";
          this.form.numberOther = "";
        }
      }
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveRO02", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    getRO02() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO02", this.$route.query.id)
        .then((res) => {
          console.log("getRO02 : ", res);
          this.form.researchID = res.researchID;
          this.form.hasProtocolInitial = res.hasProtocolInitial;
          this.form.initialProtocolInitial = res.initialProtocolInitial;
          this.form.versionProtocolInitial = res.versionProtocolInitial;
          this.selectDate(res.dateProtocolInitial, "menu_date1");
          this.form.dateProtocolInitial = res.dateProtocolInitial;
          this.form.numberProtocolInitial = res.numberProtocolInitial;
          this.form.hasCorrectedProtocol = res.hasCorrectedProtocol;
          this.form.initialCorrectedProtocol = res.initialCorrectedProtocol;
          this.form.versionCorrectedProtocol = res.versionCorrectedProtocol;
          this.selectDate(res.dateCorrectedProtocol, "menu_date2");
          this.form.dateCorrectedProtocol = res.dateCorrectedProtocol;
          this.form.numberCorrectedProtocol = res.numberCorrectedProtocol;
          this.form.hasAmendment = res.hasAmendment;
          this.form.initialAmendment = res.initialAmendment;
          this.form.versionAmendment = res.versionAmendment;
          this.selectDate(res.dateAmendment, "menu_date3");
          this.form.dateAmendment = res.dateAmendment;
          this.form.numberAmendment = res.numberAmendment;
          this.form.hasSAE = res.hasSAE;
          this.form.initialSAE = res.initialSAE;
          this.form.versionSAE = res.versionSAE;
          this.selectDate(res.dateSAE, "menu_date4");
          this.form.dateSAE = res.dateSAE;
          this.form.numberSAE = res.numberSAE;
          this.form.hasProgressReport = res.hasProgressReport;
          this.form.initialProgressReport = res.initialProgressReport;
          this.form.versionProgressReport = res.versionProgressReport;
          this.selectDate(res.dateProgressReport, "menu_date5");
          this.form.dateProgressReport = res.dateProgressReport;
          this.form.numberProgressReport = res.numberProgressReport;
          this.form.hasFinalReport = res.hasFinalReport;
          this.form.initialFinalReport = res.initialFinalReport;
          this.form.versionFinalReport = res.versionFinalReport;
          this.selectDate(res.dateFinalReport, "menu_date6");
          this.form.dateFinalReport = res.dateFinalReport;
          this.form.numberFinalReport = res.numberFinalReport;
          this.form.hasProtocolDeviation = res.hasProtocolDeviation;
          this.form.initialProtocolDeviation = res.initialProtocolDeviation;
          this.form.versionProtocolDeviation = res.versionProtocolDeviation;
          this.selectDate(res.dateProtocolDeviation, "menu_date7");
          this.form.dateProtocolDeviation = res.dateProtocolDeviation;
          this.form.numberProtocolDeviation = res.numberProtocolDeviation;
          this.form.hasCD = res.hasCD;
          this.form.initialCD = res.initialCD;
          this.form.versionCD = res.versionCD;
          this.selectDate(res.dateCD, "menu_date8");
          this.form.dateCD = res.dateCD;
          this.form.numberCD = res.numberCD;
          this.form.hasOther = res.hasOther;
          this.form.detailOther = res.detailOther;
          this.form.initialOther = res.initialOther;
          this.form.versionOther = res.versionOther;
          this.selectDate(res.dateOther, "menu_date9");
          this.form.dateOther = res.dateOther;
          this.form.numberOther = res.numberOther;
          this.selectDate(res.considerDate, "considerDate");
          this.form.considerDate = res.considerDate;
          this.selectDate(res.considerDate2, "considerDate2");
          this.form.considerDate2 = res.considerDate2;
          this.form.coordinator = res.coordinator;
          this.form.receiver = res.receiver;
          this.form.receiverAndSender = res.receiverAndSender;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    selectDate(val, name) {
      if (name === "menu_date1") {
        this.menu_date1 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange1 = changeDate;
        this.form.dateProtocolInitial = val;
      }
      if (name === "menu_date2") {
        this.menu_date2 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange2 = changeDate;
        this.form.dateCorrectedProtocol = changeDate;
      }
      if (name === "menu_date3") {
        this.menu_date3 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange3 = changeDate;
        this.form.dateAmendment = val;
      }
      if (name === "menu_date4") {
        this.menu_date4 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange4 = changeDate;
        this.form.dateSAE = val;
      }
      if (name === "menu_date5") {
        this.menu_date5 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange5 = changeDate;
        this.form.dateProgressReport = val;
      }
      if (name === "menu_date6") {
        this.menu_date6 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange6 = changeDate;
        this.form.dateFinalReport = val;
      }
      if (name === "menu_date7") {
        this.menu_date7 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange7 = changeDate;
        this.form.dateProtocolDeviation = val;
      }
      if (name === "menu_date8") {
        this.menu_date8 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange8 = changeDate;
        this.form.dateCD = val;
      }
      if (name === "menu_date9") {
        this.menu_date9 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange9 = changeDate;
        this.form.dateOther = val;
      }
      if (name === "considerDate") {
        this.considerDate = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.considerDateChange = changeDate;
        this.form.considerDate = val;
      }
      if (name === "considerDate2") {
        this.considerDate2 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.considerDate2Change = changeDate;
        this.form.considerDate2 = val;
      }
    },
    // Change Date
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },

    setData() {
      this.form.hasProtocolInitial = true;
      this.form.initialProtocolInitial = "Test";
      this.form.versionProtocolInitial = "Test";
      this.form.dateProtocolInitial = "2020-02-12";
      this.form.numberProtocolInitial = "Test";
      this.form.hasCorrectedProtocol = true;
      this.form.initialCorrectedProtocol = "Test";
      this.form.versionCorrectedProtocol = "Test";
      this.form.dateCorrectedProtocol = "2020-02-12";
      this.form.numberCorrectedProtocol = "Test";
      this.form.hasAmendment = true;
      this.form.initialAmendment = "Test";
      this.form.versionAmendment = "Test";
      this.form.dateAmendment = "2020-02-12";
      this.form.numberAmendment = "Test";
      this.form.hasSAE = true;
      this.form.initialSAE = "Test";
      this.form.versionSAE = "Test";
      this.form.dateSAE = "2020-02-12";
      this.form.numberSAE = "Test";
      this.form.hasProgressReport = true;
      this.form.initialProgressReport = "Test";
      this.form.versionProgressReport = "Test";
      this.form.dateProgressReport = "2020-02-12";
      this.form.numberProgressReport = "Test";
      this.form.hasFinalReport = true;
      this.form.initialFinalReport = "Test";
      this.form.versionFinalReport = "Test";
      this.form.dateFinalReport = "2020-02-12";
      this.form.numberFinalReport = "Test";
      this.form.hasProtocolDeviation = true;
      this.form.initialProtocolDeviation = "Test";
      this.form.versionProtocolDeviation = "Test";
      this.form.dateProtocolDeviation = "2020-02-12";
      this.form.numberProtocolDeviation = "Test";
      this.form.hasCD = true;
      this.form.initialCD = "Test";
      this.form.versionCD = "Test";
      this.form.dateCD = "2020-02-12";
      this.form.numberCD = "Test";
      this.form.hasOther = true;
      this.form.detailOther = "Test";
      this.form.initialOther = "Test";
      this.form.versionOther = "Test";
      this.form.dateOther = "2020-02-12";
      this.form.numberOther = "Test";
      this.form.considerDate = "2020-02-12";
      this.form.considerDate2 = "2020-02-12";
      this.form.coordinator = "Test";
      this.form.receiver = "Test";
      this.form.receiverAndSender = "Test";
    },
  },
};
</script>

<style lang="scss">
.table-ro {
  /*** Table Styles **/
  .table-style {
    .table-fill {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      border-bottom: 5px solid #544a44;
    }

    th {
      color: #000000;
      background: #faf5f2;
      border-top: 5px solid #544a44;
      border-right: 1px solid #544a44;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    /*th:first-child {*/
    /*    border-top-left-radius:3px;*/
    /*}*/

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr {
      border-top: 0.5px solid #544a44;
      border-bottom-: 0.5px solid #544a44;
      color: #ffffff;
    }

    /*tr:hover td {*/
    /*    background:#4E5066;*/
    /*    color:#FFFFFF;*/
    /*    border-top: 1px solid #22262e;*/
    /*}*/

    tr:first-child {
      border-top: none;
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    /*tr:nth-child(odd) td {*/
    /*    background:#EBEBEB;*/
    /*}*/

    /*tr:nth-child(odd):hover td {*/
    /*    background:#4E5066;*/
    /*}*/

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid #544a44;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}
.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>
